import { OnInit } from '@angular/core';
import { ClientService } from '../../shared/services/client.service';
import { ManagedClient } from '../../shared/models/managed-client';
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { DacConfig } from "../../shared/services/dac-config.service";
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from 'app/login/services/auth.service';
// Todo: Stephen I'm not sure how much the wordpress stuff works and may just need to be removed.
var ClientNewComponent = /** @class */ (function () {
    function ClientNewComponent(_clientService, router, location, alertService, authService, dacConfig) {
        var _this = this;
        this._clientService = _clientService;
        this.router = router;
        this.location = location;
        this.alertService = alertService;
        this.authService = authService;
        this.dacConfig = dacConfig;
        this._client = new ManagedClient();
        this.authService.getCurrentUser().then(function (user) {
            _this._client.user = user;
        });
        this.isSaving = false;
    }
    ClientNewComponent.prototype.ngOnInit = function () {
        this.generateClientId();
    };
    Object.defineProperty(ClientNewComponent.prototype, "isGeneratingClientId", {
        get: function () {
            return this._generatingClientId;
        },
        enumerable: true,
        configurable: true
    });
    ClientNewComponent.prototype.generateClientId = function () {
        var _this = this;
        this._generatingClientId = true;
        this._clientService.generateClientId().then(function (id) {
            _this._client.id = id;
            _this._generatingClientId = false;
        })
            .catch(function (error) {
            _this.alertService.error("There was an error generating the client id for this client.  Please press the generate button again or contact support");
            console.error(error);
        });
    };
    ClientNewComponent.prototype.goBack = function () {
        this.location.back();
    };
    Object.defineProperty(ClientNewComponent.prototype, "shouldShowEmailTemplate", {
        get: function () {
            return this.dacConfig.isFeatureEnabled("assessments.manage.emailtemplate");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientNewComponent.prototype, "Client", {
        get: function () {
            return this._client;
        },
        set: function (v) {
            this._client = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClientNewComponent.prototype, "showPasswordFields", {
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    ClientNewComponent.prototype.validate = function () {
        var errors = [];
        if (this.showPasswordFields) {
            if (this.password.trim() === "") {
                errors.push("Password cannot be empty");
            }
            else if (this.password !== this.confirmPassword) {
                errors.push("Passwords do not match");
            }
            else if (this.password.length < 8) {
                errors.push("Password must be at least 8 characters long");
            }
        }
        if (this._client.id === null
            || this._client.id.trim() === "") {
            errors.push("Unique Client Login ID cannot be empty");
        }
        return errors;
    };
    ClientNewComponent.prototype.setUser = function (user) {
        this.Client.user = user;
    };
    ClientNewComponent.prototype.save = function (isValid) {
        var _this = this;
        if (!isValid) {
            this.alertService.error("You must fill in all required fields");
            return;
        }
        var errors = this.validate();
        if (errors.length) {
            this.alertService.error(errors.join("."), 3000);
            return;
        }
        this.isSaving = true;
        this._client.customField1 = this._client.id;
        this._clientService.createClient(this._client).then(function (client) {
            _this.handleClientCreateSuccess();
        })
            .catch(function (error) {
            _this.isSaving = false;
            console.error(error);
            if (error._code && error._code == "DUP_ENTRY") {
                _this.alertService.error("That Unique Token already exists.  Please choose another one.", 3000);
            }
            else {
                _this.alertService.error("An error occurred in saving this client.  Try again or contact customer support", 3000);
            }
        });
    };
    ClientNewComponent.prototype.handleClientCreateSuccess = function () {
        var _this = this;
        this.alertService.success("Client was created");
        setTimeout(function () {
            _this.isSaving = false;
            _this.router.navigate(['admin', 'client', _this._client.id], { replaceUrl: true });
        }, 1000);
    };
    return ClientNewComponent;
}());
export { ClientNewComponent };



// WEBPACK FOOTER //
// ./src/app/admin/client-new/client-new.component.ts.pre-build-optimizer.js